// extracted by mini-css-extract-plugin
export default {"maskForm":"maskForm--mp95Q","tabsWrapper":"tabsWrapper--OTEvv"};